import CustomSlider from "./custom-slider";

class HowItWorksSlider {  

  private sliderTrack: HTMLElement | null = null;
  private customSlider: CustomSlider | null = null;

  constructor() {
    this.sliderTrack = document.querySelector(".how-it-works__slider-track-el");
    if (!this.sliderTrack) return;
    this.customSlider = new CustomSlider(this.sliderTrack, {
      autoplay: true,
      endless: true,
    });
  }
}

export default function howItWorksSlider() {
  return new HowItWorksSlider();
}